module.exports = __webpack_public_path__ + "static/media/ios-pin.cc6b9d96.svg";